/**
 * @description: 关闭支付、线下完成支付，标识
 * @param {*} h
 * @param {*} ctx
 * @param {*} r
 * @returns {*}
 */
export const payStatusIcon = (h, ctx, r) => {
  let isCloseOrrgType = !!+r.closeOrRgType && +r.closeOrRgStatus === 2;
  if (r.specialFlag !== undefined) isCloseOrrgType = !!+r.specialFlag;

  return (
    <span>
      {isCloseOrrgType && (
        <i
          class="el-icon-info"
          style="font-size: 17px; color: red; margin-left: 5px"
        ></i>
      )}
    </span>
  );
};
